"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19789],{

/***/ 19789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useCart; }
/* harmony export */ });
/* harmony import */ var _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _redux_actions_basket__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4281);
/* harmony import */ var _redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14596);
/* harmony import */ var _redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12664);
/* harmony import */ var _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20031);
/* harmony import */ var _typings_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88039);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36456);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66026);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8972);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16502);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var _utils_gtag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65809);
/* provided dependency */ var process = __webpack_require__(34155);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var SnackBarMessage;
(function(SnackBarMessage) {
    SnackBarMessage["ADD"] = 'add';
    SnackBarMessage["ADD_TRYOUT"] = 'add tryout';
    SnackBarMessage["MAX"] = 'max';
    SnackBarMessage["REMOVE"] = 'remove';
    SnackBarMessage["DELETE"] = 'delete';
    SnackBarMessage["LIMIT"] = 'limit';
    SnackBarMessage["ADD_MULTIPLE"] = 'add-multiple';
})(SnackBarMessage || (SnackBarMessage = {}));
var googleAnalyticsId = process.env.NEXT_PUBLIC_GA_ID;
var googleTagManagerId = process.env.NEXT_PUBLIC_GTM_ID;
var noMixedBasket = process.env.NO_MIXED_BASKET;
function getMixedBasketCondition(items, data) {
    if (!noMixedBasket) return false;
    var cartProductType = items.length && items[0].type;
    var addRentalInSecondHandCart = cartProductType === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .ORDER_ITEM_TYPE.SECOND_HAND */ ._$.SECOND_HAND && !data.secondHand;
    var addSecondHandInRentalCart = !(cartProductType === _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .ORDER_ITEM_TYPE.SECOND_HAND */ ._$.SECOND_HAND) && data.secondHand;
    return cartProductType && (addRentalInSecondHandCart || addSecondHandInRentalCart);
}
function getAddedProduct(data, response) {
    var productCode = data.productCode, variantCode = data.variantCode;
    var withTryingOn = data.withTryingOn || false;
    var product = response.items.find(function(item) {
        return item.product.code === productCode && item.withTryingOn === withTryingOn && (item.product.isSimpleProduct || item.product.variants[0].code === variantCode);
    });
    return product;
}
function getPuid(data) {
    var units = data.units;
    return units && units[0].puid;
}
function getMaximumItemsInCart(items, maximumItemsInCart) {
    var itemsInCartNumber = items.reduce(function(accumulator, currentValue) {
        return accumulator + currentValue.quantity;
    }, 0);
    return itemsInCartNumber === maximumItemsInCart;
}
function useCart() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_8__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var cart = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.cart) === null || ref === void 0 ? void 0 : ref.item;
    });
    var maximumItemsInCart = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        var ref, ref1;
        return (ref = state.parameters) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.maximumItemsInCart;
    });
    var token1 = cart === null || cart === void 0 ? void 0 : cart.tokenValue;
    var items = (cart === null || cart === void 0 ? void 0 : cart.items) || [];
    function addProductToCart(data) {
        return _addProductToCart.apply(this, arguments);
    }
    function _addProductToCart() {
        _addProductToCart = _asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var isMaximumItemsInCart, isBasketMixed, response;
            return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isMaximumItemsInCart = getMaximumItemsInCart(items, maximumItemsInCart);
                        if (!isMaximumItemsInCart) {
                            _ctx.next = 4;
                            break;
                        }
                        enqueueSnackbar({
                            message: SnackBarMessage.LIMIT
                        });
                        return _ctx.abrupt("return");
                    case 4:
                        isBasketMixed = getMixedBasketCondition(items, data);
                        if (!isBasketMixed) {
                            _ctx.next = 8;
                            break;
                        }
                        dispatch((0,_redux_actions_basket__WEBPACK_IMPORTED_MODULE_1__/* .setOpenNoMixedBasketModal */ .qj)(true));
                        return _ctx.abrupt("return");
                    case 8:
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .ADD_PRODUCT_REQUEST */ .Jy)());
                        _ctx.prev = 9;
                        _ctx.next = 12;
                        return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                            method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods.post */ .YZ.post,
                            url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                            uid: token1 + '/items',
                            data: data
                        });
                    case 12:
                        response = _ctx.sent;
                        if (googleAnalyticsId) {
                            (0,_utils_gtag__WEBPACK_IMPORTED_MODULE_11__/* .handleGACartEventWithSingleProduct */ .RL)(response, getAddedProduct(data, response), _typings_base__WEBPACK_IMPORTED_MODULE_5__/* .GAEvent.ADD_TO_CART */ .g.ADD_TO_CART, getPuid(data));
                        }
                        if (googleTagManagerId) {
                            (0,_utils_gtag__WEBPACK_IMPORTED_MODULE_11__/* .handleGTMAddToCart */ .$6)(response, getAddedProduct(data, response), _typings_base__WEBPACK_IMPORTED_MODULE_5__/* .GTMEvent.ADD_TO_CART */ .t.ADD_TO_CART);
                        }
                        enqueueSnackbar({
                            message: data.withTryingOn ? SnackBarMessage.ADD_TRYOUT : SnackBarMessage.ADD
                        });
                        dispatch((0,_redux_actions_basket__WEBPACK_IMPORTED_MODULE_1__/* .setShowBasket */ .az)(true));
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .ADD_PRODUCT_SUCCESS */ .s$)(response));
                        _ctx.next = 23;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](9);
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .ADD_PRODUCT_FAILURE */ .Vh)(_ctx.t0));
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    9,
                    20
                ]
            ]);
        }));
        return _addProductToCart.apply(this, arguments);
    }
    function changeProductQuantityInCart(itemId, data, gaEvent, stock) {
        return _changeProductQuantityInCart.apply(this, arguments);
    }
    function _changeProductQuantityInCart() {
        _changeProductQuantityInCart = _asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(itemId, data, gaEvent, stock) {
            var isMaximumItemsInCart, response, product, product1;
            return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isMaximumItemsInCart = getMaximumItemsInCart(items, maximumItemsInCart);
                        if (!(gaEvent === _typings_base__WEBPACK_IMPORTED_MODULE_5__/* .GAEvent.ADD_TO_CART */ .g.ADD_TO_CART && isMaximumItemsInCart)) {
                            _ctx.next = 4;
                            break;
                        }
                        enqueueSnackbar({
                            message: SnackBarMessage.LIMIT
                        });
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(gaEvent === _typings_base__WEBPACK_IMPORTED_MODULE_5__/* .GAEvent.ADD_TO_CART */ .g.ADD_TO_CART && data.quantity > stock)) {
                            _ctx.next = 7;
                            break;
                        }
                        enqueueSnackbar({
                            message: SnackBarMessage.MAX
                        });
                        return _ctx.abrupt("return");
                    case 7:
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .PUT_PRODUCT_REQUEST */ .Y_)());
                        _ctx.prev = 8;
                        _ctx.next = 11;
                        return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                            method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods.put */ .YZ.put,
                            url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                            uid: token1 + '/items/' + itemId,
                            data: data
                        });
                    case 11:
                        response = _ctx.sent;
                        if (googleAnalyticsId) {
                            product = response.items.find(function(item) {
                                return item.id === itemId;
                            });
                            (0,_utils_gtag__WEBPACK_IMPORTED_MODULE_11__/* .handleGACartEventWithSingleProduct */ .RL)(response, product, gaEvent);
                        }
                        if (googleTagManagerId) {
                            product1 = response.items.find(function(item) {
                                return item.id === itemId;
                            });
                            (0,_utils_gtag__WEBPACK_IMPORTED_MODULE_11__/* .handleGTMAddToCart */ .$6)(response, product1, gaEvent);
                        }
                        enqueueSnackbar({
                            message: gaEvent === _typings_base__WEBPACK_IMPORTED_MODULE_5__/* .GAEvent.ADD_TO_CART */ .g.ADD_TO_CART ? SnackBarMessage.ADD : SnackBarMessage.REMOVE
                        });
                        dispatch((0,_redux_actions_basket__WEBPACK_IMPORTED_MODULE_1__/* .setShowBasket */ .az)(true));
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .PUT_PRODUCT_SUCCESS */ .yY)(response));
                        _ctx.next = 22;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](8);
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .PUT_PRODUCT_FAILURE */ .q9)(_ctx.t0));
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    19
                ]
            ]);
        }));
        return _changeProductQuantityInCart.apply(this, arguments);
    }
    var removeProductFromCart = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product, secondHandParams) {
            var quantityToRemove, response, _args = arguments;
            return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        quantityToRemove = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 1;
                        dispatch(secondHandParams ? (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_PRODUCT_SECONDHAND_REQUEST */ .Pc)() : (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_PRODUCT_REQUEST */ .bi)());
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                            method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods["delete"] */ .YZ["delete"],
                            url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                            uid: token1 + '/items/' + product.id,
                            data: secondHandParams
                        });
                    case 5:
                        response = _ctx.sent;
                        if (googleAnalyticsId) {
                            (0,_utils_gtag__WEBPACK_IMPORTED_MODULE_11__/* .handleGACartEventWithSingleProduct */ .RL)(response, product, _typings_base__WEBPACK_IMPORTED_MODULE_5__/* .GAEvent.REMOVE_FROM_CART */ .g.REMOVE_FROM_CART, secondHandParams && secondHandParams.puid, quantityToRemove);
                        }
                        if (googleTagManagerId) {
                            (0,_utils_gtag__WEBPACK_IMPORTED_MODULE_11__/* .handleGTMAddToCart */ .$6)(response, product, _typings_base__WEBPACK_IMPORTED_MODULE_5__/* .GTMEvent.REMOVE_FROM_CART */ .t.REMOVE_FROM_CART, quantityToRemove);
                        }
                        dispatch(secondHandParams ? (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_PRODUCT_SECONDHAND_SUCCESS */ .XS)(response) : (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_PRODUCT_SUCCESS */ .cO)(response));
                        dispatch((0,_redux_actions_basket__WEBPACK_IMPORTED_MODULE_1__/* .setShowBasket */ .az)(true));
                        enqueueSnackbar({
                            message: SnackBarMessage.DELETE
                        });
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](2);
                        dispatch(secondHandParams ? (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_PRODUCT_SECONDHAND_FAILURE */ .xU)(_ctx.t0) : (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_PRODUCT_FAILURE */ ._W)(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    13
                ]
            ]);
        }));
        return function(product, secondHandParams) {
            return _ref.apply(this, arguments);
        };
    }(), [
        token1
    ]);
    var deleteCart = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(_asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var callOnDatePicker, response, _args = arguments;
        return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    callOnDatePicker = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                    dispatch(callOnDatePicker ? (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_CART_DP_REQUEST */ .Vl)() : (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_CART_REQUEST */ .vh)());
                    localStorage.removeItem('CartToken');
                    if (googleAnalyticsId) {
                        (0,_utils_gtag__WEBPACK_IMPORTED_MODULE_11__/* .hangleGACartEventWithMultipleProducts */ .oA)(_typings_base__WEBPACK_IMPORTED_MODULE_5__/* .GAEvent.REMOVE_FROM_CART */ .g.REMOVE_FROM_CART, cart);
                    }
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                        method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods["delete"] */ .YZ["delete"],
                        url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                        uid: token1
                    });
                case 7:
                    response = _ctx.sent;
                    dispatch(callOnDatePicker ? (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_CART_DP_SUCCESS */ .Kk)(response) : (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_CART_SUCCESS */ .EK)(response));
                    dispatch((0,_redux_actions_basket__WEBPACK_IMPORTED_MODULE_1__/* .setShowBasket */ .az)(false));
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](4);
                    dispatch(callOnDatePicker ? (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_CART_DP_FAILURE */ .Bd)(_ctx.t0) : (0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .DELETE_CART_FAILURE */ .UQ)(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                12
            ]
        ]);
    })), [
        token1
    ]);
    var emptyCart = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function() {
        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .EMPTY_CART */ .yT)());
        localStorage.removeItem('CartToken');
    }, []);
    var createCart = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(startDate, endDate, warehouseId) {
            var response;
            return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .CREATE_CART_REQUEST */ .SM)());
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                            method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods.post */ .YZ.post,
                            url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                            data: {
                                startRentingDate: startDate.format('DD/MM/YYYY'),
                                endRentingDate: endDate.format('DD/MM/YYYY'),
                                warehouseId: warehouseId
                            }
                        });
                    case 4:
                        response = _ctx.sent;
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .CREATE_CART_SUCCESS */ .Yn)(response));
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .CREATE_CART_FAILURE */ .UY)(_ctx.t0));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function(startDate, endDate, warehouseId) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var createSubscriptionCart = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(startDate, durationInMonth, warehouseId, customLocale) {
            var response;
            return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .CREATE_SUBSCRIPTION_CART_REQUEST */ .gv)());
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                            method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods.post */ .YZ.post,
                            url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                            data: {
                                startRentingDate: startDate.format('DD/MM/YYYY'),
                                durationInMonth: durationInMonth,
                                warehouseId: warehouseId
                            },
                            customLocale: customLocale
                        });
                    case 4:
                        response = _ctx.sent;
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .CREATE_SUBSCRIPTION_CART_SUCCESS */ .Q)(response));
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .CREATE_SUBSCRIPTION_CART_FAILURE */ .tY)(_ctx.t0));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function(startDate, durationInMonth, warehouseId, customLocale) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var addMultipleProductToCart = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var response;
            return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .ADD_MULTIPLE_PRODUCT_REQUEST */ .dp)());
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                            method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods.post */ .YZ.post,
                            url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                            uid: token1 + '/multiple-items',
                            data: data
                        });
                    case 4:
                        response = _ctx.sent;
                        enqueueSnackbar({
                            message: SnackBarMessage.ADD_MULTIPLE
                        });
                        (0,_redux_actions_basket__WEBPACK_IMPORTED_MODULE_1__/* .setShowBasket */ .az)(true);
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .ADD_MULTIPLE_PRODUCT_SUCCESS */ .n8)(response));
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .ADD_MULTIPLE_PRODUCT_FAILURE */ .pu)(_ctx.t0));
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        token1
    ]);
    var getCart = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(_asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var token, response;
        return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    token = localStorage.getItem('CartToken');
                    dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .GET_CART_REQUEST */ .Pz)());
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                        method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods.get */ .YZ.get,
                        url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                        uid: token
                    });
                case 5:
                    response = _ctx.sent;
                    dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .GET_CART_SUCCESS */ .Dg)(response));
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](2);
                    dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .GET_CART_FAILURE */ .E6)(_ctx.t0));
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                9
            ]
        ]);
    })), [
        token1
    ]);
    var updateCartSubscription = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(_asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .UPDATE_CART_SUBSCRIPTION_REQUEST */ .eV)());
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                        method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods.post */ .YZ.post,
                        url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_9__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE)),
                        uid: token1 + '/auto-update'
                    });
                case 4:
                    response = _ctx.sent;
                    dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .UPDATE_CART_SUBSCRIPTION_SUCCESS */ .xr)(response));
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](1);
                    dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .UPDATE_CART_SUBSCRIPTION_FAILURE */ .kW)(_ctx.t0));
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                8
            ]
        ]);
    })), [
        token1
    ]);
    var patchDatesCart = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var response;
            return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .PATCH_CART_DATES_REQUEST */ .eX)());
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                            method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods.patch */ .YZ.patch,
                            url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                            uid: token1,
                            data: data
                        });
                    case 4:
                        response = _ctx.sent;
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .PATCH_CART_DATES_SUCCESS */ .hT)(response));
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .PATCH_CART_DATES_FAILURE */ .j5)(_ctx.t0));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        token1
    ]);
    var putCoupon = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(coupon) {
            var response;
            return _home_ubuntu_build_wl_front_preprod_lizee_wl_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .PUT_CART_COUPON_REQUEST */ .KW)());
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,_redux_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
                            method: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .EMethods.put */ .YZ.put,
                            url: _redux_helpers_requests__WEBPACK_IMPORTED_MODULE_4__/* .ERequestUrl.createCart */ .KU.createCart,
                            uid: token1 + '/coupon',
                            data: {
                                coupon: coupon
                            }
                        });
                    case 4:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .PUT_CART_COUPON_SUCCESS */ .Vz)(response)));
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .PUT_CART_COUPON_FAILURE */ .Y1)(_ctx.t0)));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function(coupon) {
            return _ref.apply(this, arguments);
        };
    }(), [
        token1
    ]);
    var setAddressTypeCart = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)(function(type) {
        dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .SET_ADDRESS_TYPE_CART */ .fS)(type));
    }, []);
    return {
        addProductToCart: addProductToCart,
        changeProductQuantityInCart: changeProductQuantityInCart,
        removeProductFromCart: removeProductFromCart,
        deleteCart: deleteCart,
        emptyCart: emptyCart,
        createCart: createCart,
        createSubscriptionCart: createSubscriptionCart,
        addMultipleProductToCart: addMultipleProductToCart,
        getCart: getCart,
        updateCartSubscription: updateCartSubscription,
        patchDatesCart: patchDatesCart,
        putCoupon: putCoupon,
        setAddressTypeCart: setAddressTypeCart
    };
}


/***/ }),

/***/ 4281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "az": function() { return /* binding */ setShowBasket; },
/* harmony export */   "qj": function() { return /* binding */ setOpenNoMixedBasketModal; }
/* harmony export */ });
/* unused harmony export actions */
var actions = {
    SET_SHOW_BASKET: 'SET_SHOW_BASKET',
    SET_OPEN_NO_MIXED_BASKET_MODAL: 'SET_OPEN_NO_MIXED_BASKET_MODAL'
};
var setShowBasket = function(isOpen) {
    return {
        type: 'SET_SHOW_BASKET',
        isOpen: isOpen
    };
};
var setOpenNoMixedBasketModal = function(isOpen) {
    return {
        type: actions.SET_OPEN_NO_MIXED_BASKET_MODAL,
        isOpen: isOpen
    };
};


/***/ })

}]);